import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const truncate = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};
const childrenFirstCell = {
  '&.w5-cell__children-first-cell': {
    width: 'calc(100% - 20px)'
  }
};
export default theme => ({
  '& .w5-row-loader:hover': {
    backgroundColor: theme.colors.primary.white
  },
  '& .w5-row-children': {
    '&.ag-row, &.ag-row-even': {
      backgroundColor: theme.colors.actionMinor[50]
    }
  },
  '& .ag-full-width-container': {
    width: '100%',
    '& .w5-row.w5-row-full-width': {
      '& .w5-cell': _objectSpread(_objectSpread({
        height: '100%',
        paddingLeft: '16px',
        paddingRight: '16px',
        backgroundColor: theme.colors.actionMinor[50]
      }, theme.typography.defaultText), {}, {
        color: theme.colors.utility.textSecondary,
        '& .w5-full-width-divider-cell': {
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          '& .w5-full-width-divider-cell__content': {
            display: 'flex'
          }
        }
      })
    }
  },
  '& .w5-row': {
    '&.ag-row-hover': {
      '& .w5-cell-container': {
        '& .w5-cell': {
          '& .w5-cell-checkbox': {
            visibility: 'visible'
          },
          '& .w5-cell-favorite': {
            visibility: 'visible'
          },
          '& .w5-toggle-cell': {
            '&.w5-toggle-cell--highlight-hover': {
              display: 'block'
            }
          }
        }
      }
    },
    '&.w5-row--click': {
      '& .w5-cell-container': {
        cursor: 'pointer'
      }
    },
    '&.ag-row-selected': {
      backgroundColor: `${theme.colors.semantic.infoCustom50}33`,
      '& .w5-first-cell-row-selectable': {
        '&:before': {
          content: '""',
          position: 'absolute',
          width: '5px',
          height: '50px',
          left: 0,
          backgroundColor: theme.colors.actionMajor[500]
        }
      }
    },
    '&.ag-row-dragging': {
      opacity: '1',
      '& path': {
        fill: theme.colors.primary.white
      },
      '& .w5-tag-element': {
        background: theme.colors.primary.white,
        '& .w5-tag-element__content': {
          color: theme.colors.semantic.info400
        }
      }
    },
    '&.w5-row-group--open': {
      '& .w5-cell-container': {
        '& .w5-cell': {
          '& .w5-group-chevron': {
            '& svg': {
              transform: 'rotate(90deg)',
              transition: '0.3s'
            }
          }
        }
      }
    },
    '&.w5-row-group--open__no-events': {
      '& .w5-cell-container': {
        '& .w5-cell': {
          '& .w5-group-chevron': {
            pointerEvents: 'none'
          }
        }
      }
    },
    '&.w5-row-group--close': {
      '& .w5-cell-container': {
        '& .w5-cell': {
          '& .w5-group-chevron': {
            pointerEvents: 'default',
            '& svg': {
              transform: 'rotate(0deg)',
              transition: '0.3s'
            }
          }
        }
      }
    },
    '& .w5-cell-container': {
      height: '100%',
      boxSizing: 'border-box',
      '& input': {
        color: theme.colors.utility.textPrimary
      },
      '&.w5-cell-container--no-border-left-and-right': {
        borderLeft: 'none',
        borderRight: 'none'
      },
      '&.w5-cell-container--no-border-left': {
        borderLeft: 'none'
      },
      '&.w5-cell-container--no-border-right': {
        borderRight: 'none'
      },
      '&.w5-cell-container-custom-cell': {
        '&.w5-cell-container-no-drag': {
          '&.ag-cell': {
            paddingLeft: '0px',
            paddingRight: '0px'
          },
          '& .w5-cell': {
            paddingLeft: '16px',
            paddingRight: '16px'
          },
          '& .ag-row-drag': {
            '&.ag-hidden': {
              display: 'none !important'
            }
          },
          '&.w5-cell-container-lazy-drag-custom': {
            '&.ag-cell': {
              paddingLeft: '0px',
              paddingRight: '0px',
              '& .ag-row-drag': {
                paddingLeft: '16px',
                paddingRight: '16px'
              },
              '& .w5-cell': {
                paddingLeft: '16px',
                paddingRight: '16px',
                '& .w5-cell__custom-dragger': {
                  width: '21px',
                  height: '21px',
                  cursor: 'grab',
                  '& svg': {
                    display: 'block',
                    width: '21px',
                    height: '21px'
                  }
                }
              }
            }
          }
        },
        '&.w5-cell-container-drag': {
          '&.ag-cell': {
            paddingLeft: '0px',
            paddingRight: '0px',
            '& .ag-row-drag': {
              paddingLeft: '16px',
              paddingRight: '8px'
            },
            '& .w5-cell': {
              paddingLeft: '16px',
              paddingRight: '16px',
              '&.w5-cell-drag': {
                paddingLeft: '0px'
              }
            }
          },
          '& .ag-row-drag': {
            fontSize: 'inherit',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            minWidth: 42,
            '& .ag-icon': {
              fontSize: 'inherit',
              width: 18,
              textAlign: 'center',
              '&.ag-icon-grip:before': {
                content: `url("data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' width='7px' height='12px' viewBox='0 0 7 12'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 10.5C0 9.675.675 9 1.5 9S3 9.675 3 10.5 2.325 12 1.5 12 0 11.325 0 10.5zM3 6c0 .825-.675 1.5-1.5 1.5S0 6.825 0 6s.675-1.5 1.5-1.5S3 5.175 3 6zm0-4.5C3 2.325 2.325 3 1.5 3S0 2.325 0 1.5.675 0 1.5 0 3 .675 3 1.5zm.75 9c0-.825.675-1.5 1.5-1.5s1.5.675 1.5 1.5-.675 1.5-1.5 1.5-1.5-.675-1.5-1.5zm3-4.5c0 .825-.675 1.5-1.5 1.5s-1.5-.675-1.5-1.5.675-1.5 1.5-1.5 1.5.675 1.5 1.5zm0-4.5c0 .825-.675 1.5-1.5 1.5s-1.5-.675-1.5-1.5S4.425 0 5.25 0s1.5.675 1.5 1.5z' fill='%23273C50' fill-opacity='.6'/%3E%3C/svg%3E")`
              }
            }
          }
        },
        '&.w5-cell-container--dragging': {
          backgroundColor: theme.colors.semantic.info500,
          color: theme.colors.actionMinor[50],
          '& .w5-circle-percentage__text': {
            fill: `${theme.colors.actionMinor[50]} !important`
          },
          '& .w5-cell--bold': {
            color: theme.colors.actionMinor[50],
            fontWeight: 500
          },
          '& .ag-row-drag': {
            fontSize: 'inherit',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            '& .ag-icon': {
              fontSize: 'inherit',
              '&.ag-icon-grip:before': {
                content: `url("data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' width='7px' height='12px' viewBox='0 0 7 12'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 10.5C0 9.675.675 9 1.5 9S3 9.675 3 10.5 2.325 12 1.5 12 0 11.325 0 10.5zM3 6c0 .825-.675 1.5-1.5 1.5S0 6.825 0 6s.675-1.5 1.5-1.5S3 5.175 3 6zm0-4.5C3 2.325 2.325 3 1.5 3S0 2.325 0 1.5.675 0 1.5 0 3 .675 3 1.5zm.75 9c0-.825.675-1.5 1.5-1.5s1.5.675 1.5 1.5-.675 1.5-1.5 1.5-1.5-.675-1.5-1.5zm3-4.5c0 .825-.675 1.5-1.5 1.5s-1.5-.675-1.5-1.5.675-1.5 1.5-1.5 1.5.675 1.5 1.5zm0-4.5c0 .825-.675 1.5-1.5 1.5s-1.5-.675-1.5-1.5S4.425 0 5.25 0s1.5.675 1.5 1.5z' fill='%23ffffff'/%3E%3C/svg%3E") !important`
              }
            }
          },
          '& .w5-group-chevron': {
            '& svg path': {
              fill: theme.colors.actionMinor[50]
            }
          }
        },
        '& .ag-cell-value': {
          height: '100%',
          overflow: 'initial'
        },
        '& .ag-row-drag': {
          '&.ag-hidden': {
            width: '28px',
            display: 'block !important',
            '& .ag-icon-grip': {
              display: 'none'
            }
          }
        }
      },
      '& .ag-react-container': {
        height: '100%'
      },
      '& .w5-cell': {
        height: '100%',
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'flex',
        lineHeight: '1.428',
        alignItems: 'center',
        position: 'relative',
        '&.w5-cell--align-left': {
          justifyContent: 'flex-start'
        },
        '&.w5-cell--align-center': {
          justifyContent: 'center'
        },
        '&.w5-cell--align-right': {
          justifyContent: 'flex-end'
        },
        '&.w5-cell--margin': {
          marginLeft: '28px'
        },
        '&.w5-cell--bold': {
          color: theme.colors.utility.textPrimary,
          fontWeight: 500
        },
        '&.w5-cell--link': {
          color: theme.colors.actionMajor[500]
        },
        '&.w5-cell--click': {
          cursor: 'pointer',
          '&.w5-cell-click--with-hover': {
            color: theme.colors.utility.textPrimary,
            '&:hover': {
              color: theme.colors.actionMajor[500]
            }
          }
        },
        '&.w5-cell--non-click-with-hover': {
          color: theme.colors.utility.textPrimary,
          '&:hover': {
            color: theme.colors.actionMajor[500]
          }
        },
        '& .w5-cell__external-drag': {
          width: '24px',
          height: '24px',
          marginRight: '4px',
          display: 'flex',
          alignItems: 'center',
          cursor: 'grab',
          '& .w5-cell__external-drag__container': {
            width: '100%',
            height: '100%'
          }
        },
        '& .w5-multi-tag-cell': {
          display: 'flex',
          gap: 8
        },
        '& a': {
          color: theme.colors.actionMajor[500],
          textDecoration: 'none'
        },
        '& .w5-cell-link-wrapper': {
          width: '100%',
          height: '100%',
          display: 'flex',
          overflow: 'hidden',
          alignItems: 'center',
          '&.w5-cell-link-wrapper--with-hover': {
            color: theme.colors.utility.textPrimary,
            '&:hover': {
              color: theme.colors.actionMajor[500]
            }
          }
        },
        '& .w5-loader-cell': {
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          '& .w5-loader-cell__group': {
            textAlign: 'center',
            alignSelf: 'center',
            '& .w5-loader-cell__spinner': {
              display: 'inline-block',
              animation: '$spinAnimation 1s linear infinite',
              borderColor: 'transparent',
              borderTopColor: theme.colors.actionMajor[500],
              borderStyle: 'solid',
              borderWidth: '3px',
              borderRadius: '50%',
              height: '45px',
              width: '45px',
              marginBottom: '-3px'
            }
          }
        },
        '& .w5-text-cell': _objectSpread(_objectSpread({}, truncate), {}, {
          '&.w5-text-cell--uppercase': {
            textTransform: 'uppercase'
          }
        }, childrenFirstCell),
        '& .w5-text-cell__placeholder': {
          fontStyle: 'italic',
          color: `${theme.colors.grey[500]} !important`
        },
        '& .w5-text-cell-two-values': _objectSpread({
          width: '100%',
          display: 'flex',
          '&.w5-text-cell-two-values--uppercase': {
            textTransform: 'uppercase'
          },
          '& .w5-text-cell-two-values--left': {
            width: 'calc(50% - 5px)',
            margiRight: '10px',
            textAlign: 'right'
          },
          '& .w5-text-cell-two-values--right': _objectSpread(_objectSpread({}, truncate), {}, {
            width: 'calc(50% - 5px)',
            marginLeft: '10px',
            textAlign: 'left'
          })
        }, childrenFirstCell),
        '& .w5-number-cell': _objectSpread(_objectSpread({}, truncate), {}, {
          width: '100%',
          textAlign: 'right'
        }, childrenFirstCell),
        '& .w5-currency-cell': _objectSpread({}, truncate),
        '& .w5-date-cell': _objectSpread({}, truncate),
        '& .w5-boolean-cell': {
          '& > svg': {
            height: '18px'
          }
        },
        '& .w5-avatar-cell__wrapper': {
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          overflow: 'hidden',
          '& .w5-tag-element': {
            alignSelf: 'center'
          }
        },
        '& .w5-avatar-cell': _objectSpread({
          display: 'flex',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          '& .w5-avatar-cell__img-container': {
            position: 'relative',
            alignSelf: 'center',
            '& .w5-avatar-cell__img-box': {
              borderRadius: '50%',
              overflow: 'hidden',
              height: '100%',
              width: '100%',
              backgroundColor: theme.colors.grey[50],
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '&.w5-avatar-cell__img-box--small': {
                height: '18px',
                width: '18px'
              },
              '&.w5-avatar-cell__img-box--medium': {
                height: '24px',
                width: '24px'
              },
              '&.w5-avatar-cell__img-box--big': {
                height: '32px',
                width: '32px'
              },
              '&.w5-avatar-cell__img-box--png': {
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex'
              },
              '& .w5-avatar-cell__img-box--initials': {
                fontSize: '12px',
                color: 'white',
                fontStyle: 'bold',
                position: 'absolute',
                lineHeight: '50px'
              },
              '&.w5-avatar-cell__img-box--squared': {
                borderRadius: '0'
              },
              '&.w5-avatar-cell__img-box--only-icon': {
                backgroundColor: theme.colors.transparent
              },
              '& > img': {
                height: '100%',
                width: '100%',
                objectFit: 'cover',
                textAlign: 'center'
              },
              "& > img[src=''], & > img:not([src])": {
                opacity: 0
              },
              '& > svg': {
                display: 'block'
              }
            },
            '& .w5-avatar-cell__icon': {
              position: 'absolute',
              height: '15px',
              width: '15px',
              bottom: '-4px',
              right: 0,
              '& > svg': {
                height: '100%',
                width: '100%'
              }
            }
          },
          '& .w5-avatar-cell-text': _objectSpread(_objectSpread({}, truncate), {}, {
            width: 'calc(100% - 32px - 10px)',
            alignSelf: 'center',
            marginLeft: '8px'
          }),
          '& .w5-avatar-cell__text-wrapper': {
            width: 'calc(100% - 32px - 10px)',
            alignSelf: 'center',
            marginLeft: '8px',
            '& .w5-avatar-cell-text': {
              width: '100%',
              marginLeft: '0',
              color: theme.colors.primary.black,
              userSelect: 'none'
            },
            '& .w5-avatar-cell-text--secondary': _objectSpread(_objectSpread({}, truncate), {}, {
              width: '100%'
            })
          },
          '&.w5-avatar-cell--small': {
            minWidth: '18px'
          },
          '&.w5-avatar-cell--medium': {
            minWidth: '24px'
          },
          '&.w5-avatar-cell--big': {
            minWidth: '32px'
          },
          '&.w5-avatar-cell--reverse': {
            flexDirection: 'row-reverse',
            justifyContent: 'space-between',
            '& .w5-avatar-cell-text': {
              width: '100%',
              marginLeft: '0px',
              marginRight: '8px'
            }
          }
        }, childrenFirstCell),
        '& .w5-carousel-cell': _objectSpread({
          display: 'flex',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          '& .w5-carousel-cell__img-container': {
            position: 'relative',
            alignSelf: 'center',
            '& .w5-carousel-cell__img-box': {
              borderRadius: '50%',
              overflow: 'hidden',
              height: '100%',
              width: '100%',
              '&.w5-carousel-cell__img-box--small': {
                height: '18px',
                width: '18px'
              },
              '&.w5-carousel-cell__img-box--medium': {
                height: '24px',
                width: '24px'
              },
              '&.w5-carousel-cell__img-box--big': {
                height: '32px',
                width: '32px'
              },
              '&.w5-carousel-cell__img-box--squared': {
                borderRadius: '0'
              },
              '&.w5-carousel-cell__img-box__with-popover': {
                cursor: 'pointer'
              },
              '& > img': {
                height: '100%',
                width: '100%',
                objectFit: 'cover',
                textAlign: 'center',
                borderRadius: 4
              },
              '& > img[src=""], & > img:not([src])': {
                opacity: 0
              }
            }
          },
          '& .w5-carousel-cell__text-wrapper': {
            width: 'calc(100% - 32px - 10px)',
            alignSelf: 'center',
            marginLeft: '8px',
            '& .w5-carousel-cell__text': _objectSpread(_objectSpread({}, truncate), {}, {
              width: '100%',
              color: theme.colors.primary.black
            }),
            '& .w5-carousel-cell__description': {
              display: 'flex',
              alignItems: 'center'
            },
            '& .w5-carousel-cell__description-text': _objectSpread(_objectSpread({}, truncate), {}, {
              marginRight: 4
            })
          },
          '&.w5-carousel-cell--small': {
            minWidth: '18px'
          },
          '&.w5-carousel-cell--medium': {
            minWidth: '24px'
          },
          '&.w5-carousel-cell--big': {
            minWidth: '32px'
          }
        }, childrenFirstCell),
        '& .w5-value-percentage-cell': {
          width: '100%',
          display: 'flex',
          '& .w5-value-percentage-cell__text': {
            width: 'calc(50% - 10px)',
            textAlign: 'right',
            alignSelf: 'center',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
          },
          '& .w5-value-percentage-cell__divider': {
            height: '15px',
            width: '2px',
            border: `1px solid ${theme.colors.grey[50]}`,
            marginLeft: '10px',
            marginRight: '10px',
            alignSelf: 'center'
          },
          '& .w5-circle-percentage__container': {
            width: 'calc(50% - 10px)'
          }
        },
        '& .w5-percentage-text-cell': {
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          '& .w5-circle-percentage__container': {
            marginRight: '8px'
          },
          '& .w5-percentage-text-cell__text': _objectSpread({
            flex: '1'
          }, truncate)
        },
        '& .w5-multi-value-cell': {
          display: 'flex',
          whiteSpace: 'pre-wrap',
          '& .w5-multi-value-cell__extra-values': {
            color: theme.colors.actionMajor[500],
            cursor: 'pointer'
          }
        },
        '& .w5-step-cell': {
          position: 'absolute',
          left: 0,
          top: 8,
          right: 0,
          bottom: 8,
          '&.w5-step-cell--first': {
            borderRadius: '4px 0 0 4px'
          },
          '&.w5-step-cell--last': {
            borderRadius: '0 4px 4px 0'
          },
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 0,
            width: 0,
            borderTop: '15px solid transparent',
            borderBottom: '15px solid transparent',
            borderLeft: '15px solid white'
          },
          '& .w5-step-cell__content': {
            width: 'calc(100% - 15px)',
            height: '100%',
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&.w5-step-cell__content--first': {
              borderRadius: '4px 0 0 4px'
            },
            '&.w5-step-cell__content--last': {
              borderRadius: '0 4px 4px 0'
            },
            '& .w5-step-cell__content-values': {
              fontWeight: 500
            },
            '& .w5-step-cell__content-extra': _objectSpread({}, theme.typography.smallText)
          },
          '& .w5-step-cell__arrow': {
            position: 'absolute',
            width: '15px',
            marginTop: '2px',
            top: 0,
            right: 0,
            borderTop: '13px solid transparent',
            borderBottom: '13px solid transparent',
            borderLeft: '13px solid transparent'
          }
        },
        '& .w5-toggle-cell': {
          height: '18px',
          width: '18px',
          '& .w5-toggle-cell__svg-container': {
            '& svg': {
              height: '100%',
              width: '100%',
              '& path': {
                transition: 'fill 0.15s'
              },
              '&:hover': {
                cursor: 'pointer'
              }
            }
          },
          '&.w5-toggle-cell--toggled:hover': {
            '& svg': {
              '& path': {
                fill: theme.colors.actionMajor[450]
              }
            }
          },
          '&:hover': {
            '& svg': {
              '& path': {
                fill: theme.colors.grey[500]
              }
            }
          }
        },
        '& .w5-icon-cell': {
          display: 'flex',
          '& > div': {
            width: '18px',
            height: '18px',
            marginRight: '5px',
            alignSelf: 'center',
            paddingLeft: 4
          }
        },
        '& .w5-icon-cell-pointer': {
          cursor: 'pointer'
        },
        '& .w5-circle-percentage__container': {
          alignSelf: 'center',
          '& .w5-circle-percentage__content': {
            '&.w5-circle-percentage--small': {
              height: '25px',
              width: '25px'
            },
            '&.w5-circle-percentage--medium': {
              height: '35px',
              width: '35px'
            },
            '&.w5-circle-percentage--big': {
              height: '45px',
              width: '45px'
            },
            '& .w5-circle-percentage__trail': {
              stroke: theme.colors.grey[50]
            },
            '& .w5-circle-percentage__path': {
              '&.circle--red': {
                stroke: theme.colors.semantic.negative500
              },
              '&.circle--yellow': {
                stroke: theme.colors.semantic.caution500
              },
              '&.circle--green': {
                stroke: theme.colors.semantic.positive500
              }
            },
            '& .w5-circle-percentage__root': {
              '& .w5-circle-percentage__text': {
                fill: theme.colors.actionMinor[500],
                fontSize: '30px',
                fontWeight: '500',
                transform: 'translateY(3px)'
              }
            }
          }
        },
        '& .w5-group-chevron': {
          marginRight: '10px',
          alignSelf: 'center',
          cursor: 'pointer',
          '&.w5-group-chevron--open-no-events': {
            pointerEvents: 'none'
          },
          '&.w5-group-chevron--no-group': {
            marginRight: '20px'
          }
        },
        '& .w5-cell-checkbox': {
          marginRight: '8px',
          '&.w5-cell-checkbox--visible': {
            visibility: 'visible'
          },
          '&.w5-cell-checkbox--hidden': {
            visibility: 'hidden'
          },
          '& .w5-cell-checkbox__svg-container': {
            '& > svg': {
              display: 'block',
              width: '18px',
              cursor: 'pointer'
            }
          },
          '&.w5-cell-checkbox--disabled': {
            '& .w5-cell-checkbox__svg-container': {
              '& > svg': {
                cursor: 'not-allowed',
                opacity: 0.5
              }
            }
          }
        },
        '& .w5-cell-favorite': {
          marginRight: '8px',
          '&.w5-cell-favorite-none': {
            width: '18px'
          },
          '&.w5-cell-favorite--visible': {
            visibility: 'visible'
          },
          '&.w5-cell-favorite--hidden': {
            visibility: 'hidden'
          },
          '& .w5-cell-favorite__svg-container': {
            '& > svg': {
              display: 'block',
              width: '18px',
              cursor: 'pointer'
            }
          },
          '&.w5-cell-favorite--disabled': {
            '& .w5-cell-favorite__svg-container': {
              '& > svg': {
                cursor: 'not-allowed',
                opacity: 0.5
              }
            }
          }
        },
        '& .w5-drag-loader': {
          position: 'absolute',
          top: '50%',
          left: '20px',
          transform: 'translateY(-50%)',
          '& .w5-drag-loader__spinner': {
            border: `3px solid ${theme.colors.grey[50]}`,
            borderRadius: '50%',
            borderTop: `3px solid ${theme.colors.actionMajor[500]}`,
            width: '18px',
            height: '18px',
            animation: '$spin 1.5s linear infinite'
          },
          '& @keyframes spin': {
            '0%': {
              transform: 'rotate(0deg)'
            },
            '100%': {
              transform: 'rotate(360deg)'
            }
          },
          '& .w5-drag-loader__disabled': {
            height: '18px',
            width: '18px',
            borderRadius: '50%',
            backgroundColor: 'red'
          }
        }
      }
    }
  },
  '& .w5-cell-container': {
    '& .w5-cell': {
      '& .w5-toggle-cell': {
        '&.w5-toggle-cell--highlight-rest': {
          width: '18px',
          display: 'none'
        }
      }
    }
  },
  '& .w5-cell': {
    '& .w5-filter-cell': {
      display: 'flex',
      '& .w5-filter-cell__search-icon': {
        marginRight: '10px',
        display: 'flex',
        '& > svg': {
          width: '16px',
          height: '16px'
        }
      },
      '& .w5-filter-cell__input': {
        border: 'none',
        borderBottom: '1px solid transparent',
        backgroundColor: theme.colors.actionMinor[50],
        fontFamily: theme.typography.fontFamily,
        color: theme.colors.utility.textPrimary,
        borderRadius: '3px',
        padding: '0 4px',
        '&::placeholder': {
          color: theme.colors.utility.textSecondary
        }
      }
    }
  },
  '& .w5-cell__field-selector': {
    display: 'none !important'
  },
  '& .w5-tag-element': {
    height: '24px',
    boxSizing: 'border-box',
    padding: '2px 8px',
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.colors.grey[100],
    color: theme.colors.utility.textSecondary,
    '&.w5-tag-element--warning': {
      backgroundColor: theme.colors.semantic.caution100,
      color: theme.colors.semantic.caution500
    },
    '&.w5-tag-element--success': {
      backgroundColor: theme.colors.semantic.positiveCustom100,
      color: theme.colors.semantic.positive500
    },
    '&.w5-tag-element--info': {
      backgroundColor: theme.colors.semantic.infoCustom50,
      color: theme.colors.semantic.info400
    },
    '&.w5-tag-element--ongoing': {
      backgroundColor: theme.colors.temp.purple100,
      color: theme.colors.temp.purple500
    },
    '&.w5-tag-element--error': {
      backgroundColor: theme.colors.semantic.negativeCustom100,
      color: theme.colors.semantic.negative500
    },
    '&.w5-tag-element--pending': {
      backgroundColor: theme.colors.grey[100],
      color: theme.colors.utility.textSecondary
    },
    '& .w5-tag-element__content': {
      alignSelf: 'center',
      fontSize: '12px',
      lineHeight: '26px',
      fontWeight: '400',
      letterSpacing: '0.4px'
    }
  }
});